import { nanoid } from "nanoid";
import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { api, baseURL, customerReqConfig } from "../../src/include/api";

const BannerTwo = () => {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [slideList, setSlideList] = useState([]);

  const getSlides = () => {
    setFetchLoading(true);
    api
      .get("/slide_show/", customerReqConfig)
      .then((response) => {
        if (response.status === 200) {
          console.log("slide", response);

          setSlideList(response.data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching slides", error);
      })
      .finally(() => {
        setFetchLoading(false);
      });
  };

  useEffect(() => {
    getSlides();
  }, []);

  // Filter slides for each container
  const MainSlides = slideList?.filter(
    (slide) => slide.status === "active" && slide.type === "main",
  );

  return (
    <div className="banner-two">
      <div className="container container-lg">
        <div className="banner-two-wrapper d-flex align-items-start">
          <div
            className="banner-item-two-wrapper rounded-24  overflow-hidden position-relative arrow-center flex-grow-1 ms-0 ps-0 mb-0 pb-0"
            style={{
              aspectRatio: "16 / 5.2",
              paddingTop: "20px", 
              borderBottom: "24px",
            }}
          >
            {fetchLoading ? (
              <div className="w-100 bg-light" />
            ) : (
              <Carousel
                autoPlay
                className="banner-img position-absolute rounded-24 inset-block-start-0 inset-inline-start-0  object-fit-cover"
                infiniteLoop
                interval={3000}
                preventMovementUntilSwipeScrollTolerance
                showThumbs={false}
                transitionTime={100}
                showStatus={false}
                showIndicators={false} // Hides bottom dots
              >
                {MainSlides?.map((slide) => (
                  <CarouselItem slide={slide} key={nanoid()} />
                ))}
              </Carousel>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const CarouselItem = ({ slide }) => {
  const handleClick = () => {
    if (slide.linkUrl) {
      window.open(slide.linkUrl, "_blank");
    }
  };

  return (
    <div className="mx-2" style={{ cursor: "pointer" }} onClick={handleClick}>
      {/* <Link to={`/product-details/${productId}`}> */}
      <img
        className="fit-cover img-fluid"
        src={slide.imageUrl ? `${baseURL}/${slide.imageUrl}` : ""}
        alt=""
      />
      {/* </Link> */}
    </div>
  );
};

export default BannerTwo;
